import { useContext } from "react";

import { CurrentUserContext } from "../contexts/currentUserContext";

export const useCurrentUser = () => {
  const context = useContext(CurrentUserContext);

  if (context === undefined) {
    throw new Error("useCurrentUser must be used within a CurrentUserProvider");
  }

  return context;
};
